import { Fragment } from "react";
import { getUserData } from "@utils";
import NavbarUser from "./NavbarUser";
import { NavItem, NavLink } from "reactstrap";
import { Sun, Moon, Menu } from "react-feather";

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props;
  const user = getUserData();
  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />;
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    }
  };

  return (
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center">
        <ul className="navbar-nav d-xl-none">
          <NavItem className="mobile-menu me-auto">
            <NavLink
              className="nav-menu-main menu-toggle hidden-xs is-active"
              onClick={() => setMenuVisibility(true)}
            >
              <Menu className="ficon" />
            </NavLink>
          </NavItem>
        </ul>
        {/* <NavItem className="d-none d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem> */}
      </div>
      <span className="super-admin d-flex align-items-center">
        {user?.role === "superadmin" ? "Super Admin Panel" : user?.role === "admin" ? "Admin Panel" : "Partner Panel"}
      </span>
      <NavbarUser skin="light" setSkin={setSkin} />
    </Fragment>
  );
};

export default ThemeNavbar;
